import { Theme } from "@mui/material/styles";
import { createStyles } from "@mui/styles";

const colorsStyle = (theme: Theme) => createStyles({

    primary: {
        color: theme.palette.primary.main
    },
    secondary: {
        color: theme.palette.secondary.main
    },
    error: {
        color: theme.palette.error.main
    },

    info: {
        color: theme.genie.palette.info.main
    },
    success: {
        color: theme.genie.palette.success.main
    },
    warning: {
        color: theme.genie.palette.warning.main
    },
    notice: {
        color: theme.genie.palette.notice.main
    },

    muted: {
        color: theme.genie.palette.muted.main
    },
    mutedLight: {
        color: theme.genie.palette.muted.light
    },
    mutedDark: {
        color: theme.genie.palette.muted.dark
    },


    white: {
        color: theme.palette.common.white
    },
    black: {
        color: theme.palette.common.black
    },

    inherit: {
        color: "inherit"
    },
    transparent: {
        color: "transparent"
    },



    bg_primary: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.primary.contrastText,
    },
    bg_secondary: {
        backgroundColor: theme.palette.secondary.dark,
        color: theme.palette.secondary.contrastText,
    },
    bg_error: {
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.error.contrastText,
    },

    bg_info: {
        backgroundColor: theme.genie.palette.info.dark,
        color: theme.genie.palette.info.contrastText,
    },
    bg_success: {
        backgroundColor: theme.genie.palette.success.dark,
        color: theme.genie.palette.success.contrastText,
    },
    bg_warning: {
        backgroundColor: theme.genie.palette.warning.dark,
        color: theme.genie.palette.warning.contrastText,
    },
    bg_notice: {
        backgroundColor: theme.genie.palette.notice.dark,
        color: theme.genie.palette.notice.contrastText,
    },

    bg_muted: {
        backgroundColor: theme.genie.palette.muted.main,
        color: theme.genie.palette.muted.dark,
    },
    bg_mutedLight: {
        backgroundColor: theme.genie.palette.muted.light,
        color: theme.genie.palette.muted.dark,
    },
    bg_mutedDark: {
        backgroundColor: theme.genie.palette.muted.dark,
        color: theme.genie.palette.muted.contrastText,
    },

    bg_inherit: {
        color: "inherit",
        background: "inherit"
    },
    bg_transparent: {
        background: "transparent"
    },

    bc_primary: {
        borderColor: theme.palette.primary.dark,
    },
    bc_secondary: {
        borderColor: theme.palette.secondary.dark,
    },
    bc_error: {
        borderColor: theme.palette.error.dark,
    },
    bc_info: {
        borderColor: theme.genie.palette.info.dark,
    },
    bc_success: {
        borderColor: theme.genie.palette.success.dark,
    },
    bc_warning: {
        borderColor: theme.genie.palette.warning.dark,
    },
    bc_notice: {
        borderColor: theme.genie.palette.notice.dark,
    },
    bc_muted: {
        borderColor: theme.genie.palette.muted.main,
    },
    bc_mutedLight: {
        borderColor: theme.genie.palette.muted.light,
    },
    bc_mutedDark: {
        borderColor: theme.genie.palette.muted.dark,
    },
    bc_inherit: {
        borderColor: "inherit",
    },
    bc_transparent: {
        borderColor: "transparent"
    },
});

export default colorsStyle;
